import plugin from '@core/plugins/lib';
const PLUGIN_NAME = 'CommerceAnalyticsImpression';
import $ from "jquery";

const ELEMENT_SELECTOR = '[data-commerce-analytics-impression]';
const elements = document.querySelectorAll(ELEMENT_SELECTOR);

if (elements.length) {
	System.import(
		/* webpackChunkName: "commerce-analytics-impression" */ './commerce-analytics-impression'
	).then((module) => {
		plugin(PLUGIN_NAME, module.default);
		$(elements)[PLUGIN_NAME]();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/commerce-analytics-impression/index.js